import React from 'react';

export const DashboardCard: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = '' }) => (
  <div className={`rounded-2xl border border-slate-200/80 bg-white p-4 shadow-[0_10px_30px_-20px_rgba(15,23,42,0.35)] sm:p-5 ${className}`}>
    {children}
  </div>
);

export const DashboardSectionTitle: React.FC<{
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  accent?: 'default' | 'violet';
}> = ({
  title,
  subtitle,
  action,
  accent = 'default',
}) => {
  const renderAccentTitle = () => {
    if (accent !== 'violet') return title;
    const words = String(title).trim().split(/\s+/).filter(Boolean);
    if (words.length <= 1) {
      return <span className="text-slate-900">{title}</span>;
    }
    return words.map((word, index) => (
      <React.Fragment key={`${word}-${index}`}>
        <span className={index === 0 ? 'text-slate-900' : 'text-[#7c3aed]'}>{word}</span>
        {index < words.length - 1 ? ' ' : null}
      </React.Fragment>
    ));
  };

  return (
  <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
    <div>
      <h2 className="text-lg font-black text-slate-900 sm:text-xl">{renderAccentTitle()}</h2>
      {subtitle ? <p className="mt-1 text-xs font-medium text-slate-500 sm:text-sm">{subtitle}</p> : null}
    </div>
    {action}
  </div>
  );
};

export const DashboardEmptyState: React.FC<{ title: string; subtitle?: string; action?: React.ReactNode }> = ({
  title,
  subtitle,
  action,
}) => (
  <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-50/70 px-5 py-10 text-center">
    <p className="text-base font-black text-slate-800">{title}</p>
    {subtitle ? <p className="mt-2 text-sm text-slate-500">{subtitle}</p> : null}
    {action ? <div className="mt-4">{action}</div> : null}
  </div>
);
